'use es6';

import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { retrieveSchema } from '../../../utils/schemaUtils';
import { toIdSchema } from '../../../utils/idUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AddButton from '../shared/AddButton';
import RemoveButton from '../shared/RemoveButton';
import Toolbar from '../shared/Toolbar';
import SchemaField from '../SchemaField';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ArrayFieldItems extends Component {
  render() {
    const {
      autoFocus,
      canAddItem,
      canRemoveItem,
      definitions,
      disabled,
      errorSchema,
      formData,
      idPrefix,
      idSchema,
      onAddItemClick,
      onRemoveItemClick,
      onChangeForIndex,
      readOnly,
      registry,
      schema,
      showAddButton
    } = this.props;
    const has = {
      remove: canRemoveItem(formData)
    };
    has.toolbar = Object.keys(has).some(k => has[k]);
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [formData.map((item, index) => {
        const itemSchema = retrieveSchema(schema.items, definitions, item);
        const itemErrorSchema = errorSchema ? errorSchema[index] : undefined;
        const itemIdPrefix = `${idSchema.$id}_${index}`;
        const itemIdSchema = toIdSchema(itemSchema, itemIdPrefix, definitions, item, idPrefix);
        return /*#__PURE__*/_jsxs(UIFlex, {
          align: "start",
          justify: "between",
          className: "array-field-items m-bottom-2",
          children: [/*#__PURE__*/_jsx(UIBox, {
            grow: 1,
            shrink: 1,
            basis: "100%",
            children: /*#__PURE__*/_jsx(SchemaField, {
              autoFocus: autoFocus && index === formData.length - 1,
              collapsed: false,
              disabled: disabled,
              errorSchema: itemErrorSchema,
              formData: item,
              idSchema: itemIdSchema,
              onChange: onChangeForIndex(index),
              readOnly: readOnly,
              registry: registry,
              schema: itemSchema,
              parentSchemaType: schema.type
            })
          }), has.toolbar && /*#__PURE__*/_jsx(UIBox, {
            className: "m-left-6",
            children: /*#__PURE__*/_jsx(Toolbar, {
              children: has.remove && /*#__PURE__*/_jsx(RemoveButton, {
                "data-test-id": "array-item-remove",
                className: "p-y-3",
                onClick: onRemoveItemClick(index),
                disabled: disabled || readOnly,
                tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "developer-docs-shared-components.params.body.removeTestValue"
                })
              })
            })
          })]
        }, index);
      }), showAddButton && canAddItem(formData) && /*#__PURE__*/_jsx(AddButton, {
        onClick: onAddItemClick,
        disabled: disabled || readOnly,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.params.body.addTestValue"
        })
      })]
    });
  }
}
ArrayFieldItems.propTypes = {
  autoFocus: PropTypes.bool.isRequired,
  canAddItem: PropTypes.func.isRequired,
  canRemoveItem: PropTypes.func.isRequired,
  definitions: PropTypes.object,
  disabled: PropTypes.bool,
  errorSchema: PropTypes.object,
  formData: PropTypes.array.isRequired,
  idPrefix: PropTypes.string,
  idSchema: PropTypes.object.isRequired,
  onAddItemClick: PropTypes.func.isRequired,
  onRemoveItemClick: PropTypes.func.isRequired,
  onChangeForIndex: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  registry: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  showAddButton: PropTypes.bool.isRequired
};